import React from 'react';

const ExternalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="0 0 24 24"
    style={{ marginLeft: '0.33em', verticalAlign: '-0.15em', display: 'inline-block' }}
  >
    <path d="M14 3h7v7"></path>
    <path d="M10 14L21 3"></path>
    <path d="M21 14v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
  </svg>
);

const Card = ({ image, icon: Icon, iconType, iconStatus, title, subtitle, status, body, links, years, cardHref }) => {
  const cardIsExternal = cardHref?.startsWith('http');

  return (
    <article className={`project-card${cardHref ? ' project-card-clickable' : ''}`}>
      {cardHref && (
        <a
          href={cardHref}
          className="project-card-hit-area"
          aria-label={`${cardIsExternal ? 'Visit' : 'View'} ${title}${cardIsExternal ? '' : ' experience'}`}
          target={cardIsExternal ? '_blank' : undefined}
          rel={cardIsExternal ? 'noopener noreferrer' : undefined}
        />
      )}
      <div className="project-header">
        <div className="project-title">
          <div className="project-icon">
            {image ? (
              <img src={image} alt={title + ' logo'} className="project-image" />
            ) : (
              Icon && iconType && <Icon type={iconType} status={iconStatus || status} />
            )}
          </div>
          <div className="project-title-text">
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
            {years && <p className="project-years">{years}</p>}
          </div>
        </div>
        {status && <span className={`status-tag status-${status}`}>{status}</span>}
      </div>
      {body && <div className="project-description">{body}</div>}
      {links && links.length > 0 && (
        <div className="project-links">
          {links.map((link, idx) => (
            link.onClick ? (
              <button
                key={idx}
                onClick={link.onClick}
                className="project-link"
                type="button"
              >
                {`${link.label} →`}
              </button>
            ) : link.href ? (
              <a
                key={idx}
                href={link.href}
                className="project-link"
              >
                {`${link.label} →`}
              </a>
            ) : (
              <a
                key={idx}
                href={link.url}
                className="project-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.label}<ExternalIcon />
              </a>
            )
          ))}
        </div>
      )}
    </article>
  );
};

export default Card;
